// extracted by mini-css-extract-plugin
export default {"d_footer":"footer_d_footer__HtK63"};